exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".speak-with-us[data-v-867a3f84]{border-top:1px solid var(--border-primary);border-bottom:1px solid var(--border-primary)}", ""]);

// exports
